import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
 
 
 
 
export default function CCFS({
  ccfs
}: {
  ccfs: any
}) {
  const { t } = useTranslation();
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {ccfs && ccfs.length > 0 ? (<div><span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi-consulta, pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('ccfs')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('ccfs')}</span>)} </div>;
  }
 
  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };
 
  const getResumo = () => {
    const resumos: any[] = [];
    
    resumos.push({
      icon: 'pi pi-chart-line',
      label: 'Quantidade Bancos',
      value: 0
    })
    resumos.push({
      icon: 'pi pi-gauge',
      label: 'Quantidade Ocorrências',
      value: 0
    })
    resumos.push({
      icon: 'pi pi-plus',
      label: 'Quantidade Total',
      value: '0'
    })
    resumos.push({
      icon: 'pi pi-calendar-clock',
      label: 'Última Ocorrência',
      value: '0'
    })
    let valorTotal = 0
    let quantidade = 0;
    let data:Date|null = null
    const bancos: any[] = []
    ccfs.forEach((ocorrencia:any) => {
      quantidade ++;
      if(ocorrencia.quantidade){
        valorTotal = valorTotal + Number(ocorrencia.quantidade)
      }
      const [dia, mes, ano, ] = ocorrencia.ultimaOcorrencia.split(/[\/: ]/).map((v: string) => parseInt(v));
      const dataFormatada = new Date(ano, mes - 1, dia);
      if(data == null || data < dataFormatada){
        data = dataFormatada
      }
      
      if(!bancos.includes(ocorrencia.banco)){
        bancos.push(ocorrencia.banco)
      }
    });
    resumos[0].value = bancos.length;
    resumos[1].value = quantidade;
    resumos[2].value = valorTotal;
    resumos[3].value = (data ? formatDate(data) : '');
    
    return resumos;
  }
  
  return (
    <Panel headerTemplate={headerTemplate}>
      {ccfs.length === 0 ? ( <NadaConsta />) : (
      <div>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumo().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={ccfs} tableStyle={{ minWidth: '50rem' }}>
          <Column field="tipo" header={t('tipo')}></Column>
          <Column field="codigo" header={t('codigoBanco')}></Column>
          <Column field="banco" header={t('banco')}></Column>
          <Column field="agencia" header={t('agencia')}></Column>
          <Column field="motivo" header={t('motivo')}></Column>
          <Column field="quantidade" header={t('quantidade')}></Column>
          <Column field="ultimaOcorrencia" header={t('dataUltimaOcorrencia')}></Column>
      </DataTable>
      </div>
       )}
    </Panel>
  )
}